import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SignupForm } from '@/modules/auth/components/signup';
import { useGetSignupSettings } from '@/modules/auth/hooks/use-auth';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';

export const SignupPage = () => {
  const { t } = useTranslation();
  const { data: signupSettings } = useGetSignupSettings();
  // Google/SSO sign-up temporarily disabled
  // const { data: loginOption } = useGetLoginOptions();

  const isEmailPasswordSignUpEnabled = signupSettings?.isEmailPasswordSignUpEnabled ?? false;
  // const isSSoSignUpEnabled = signupSettings?.isSSoSignUpEnabled ?? false;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-1.5">
        <h2
          className="text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('SIGN_UP_TO_GET_ACCESS')}
        </h2>
        <div className="flex items-center gap-1">
          <span className="text-sm font-normal leading-5" style={{ color: LOGIN_COLORS.textMuted }}>
            {t('ALREADY_HAVE_ACCOUNT')}
          </span>
          <Link to="/login" className="text-sm font-semibold leading-5 hover:underline" style={{ color: LOGIN_COLORS.primary }}>
            {t('LOG_IN')}
          </Link>
        </div>
      </div>
      {isEmailPasswordSignUpEnabled && <SignupForm />}
      {/* <div className="flex flex-col gap-5">
        {isEmailPasswordSignUpEnabled && isSSoSignUpEnabled && (
          <Divider text={t('OR_CONTINUE_WITH')} />
        )}
        {loginOption && <SsoSignin loginOption={loginOption} />}
      </div> */}
    </div>
  );
};
